import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TherapyPlanExerciseDto } from '@therapist/shared/models/exercise/therapy-plan-exercise.dto';
import { ExerciseActivityBadgeComponent } from '../exercise-activity-badge/exercise-activity-badge.component';
import { RepetitionUnitTypeEnum } from '@therapist/shared/models/exercise/repetition-unit-type.enum';
import { JointBadgeComponent } from '../joint-badge/joint-badge.component';
import { TherapyPlanProgressDto } from '@therapist/shared/models/therapy-plan/therapy-plan-progress.dto';
import { TrainingProgressIndicatorComponent } from '@base/components/training-progress-indicator/training-progress-indicator.component';
import { TherapyPlanDto } from '@therapist/shared/models/therapy-plan/therapy-plan.dto';
import { TherapistVideoViewerComponent } from '../therapist-video-viewer/therapist-video-viewer.component';

@Component({
  selector: 'sana-tp-exercise-therapy-plan-list',
  imports: [
    ExerciseActivityBadgeComponent,
    JointBadgeComponent,
    TrainingProgressIndicatorComponent,
    TherapistVideoViewerComponent
  ],
  templateUrl: './exercise-therapy-plan-list.component.html',
  styleUrl: './exercise-therapy-plan-list.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ExerciseTherapyPlanListComponent {

  @Input({ required: true }) therapyPlan!: TherapyPlanDto;
  @Input({ required: true }) exercisesInTherapyPlanList!: TherapyPlanExerciseDto[];
  @Input({ required: true }) progress!: TherapyPlanProgressDto;

  protected readonly RepetitionUnitTypeEnum = RepetitionUnitTypeEnum;
}
